module.exports = __webpack_public_path__ + "img/compare-02.b15a4808.png";